import { L10n, createElement } from '@syncfusion/ej2-base';
import { ListView } from '@syncfusion/ej2-lists';
import { Button } from '@syncfusion/ej2-buttons';
import { DialogUtility } from '@syncfusion/ej2-popups';
/**
 * @private
 */
export class AddUserDialog {
    constructor(documentHelper) {
        /**
         * @private
         * @returns {void}
         */
        this.show = () => {
            const localObj = new L10n('documenteditor', this.documentHelper.owner.defaultLocale);
            localObj.setLocale(this.documentHelper.owner.locale);
            if (!this.target) {
                this.initUserDialog(localObj, this.documentHelper.owner.enableRtl);
            }
            this.documentHelper.dialog.header = localObj.getConstant('Add Users');
            this.documentHelper.dialog.height = 'auto';
            this.documentHelper.dialog.width = 'auto';
            this.documentHelper.dialog.content = this.target;
            this.documentHelper.dialog.beforeOpen = this.loadUserDetails;
            this.documentHelper.dialog.close = this.documentHelper.updateFocus;
            this.documentHelper.dialog.buttons = [
                {
                    click: this.okButtonClick,
                    buttonModel: {
                        content: localObj.getConstant('Ok'), cssClass: 'e-flat', isPrimary: true
                    }
                },
                {
                    click: this.hideDialog,
                    buttonModel: { content: localObj.getConstant('Cancel'), cssClass: 'e-flat' }
                }, {
                    click: this.deleteButtonClick,
                    buttonModel: { content: localObj.getConstant('Delete'), cssClass: 'e-flat e-user-delete' }
                }
            ];
            this.documentHelper.dialog.dataBind();
            this.documentHelper.dialog.show();
        };
        /**
         * @private
         * @returns {void}
         */
        this.loadUserDetails = () => {
            this.userList.dataSource = this.documentHelper.userCollection.slice();
            this.userList.dataBind();
            this.documentHelper.restrictEditingPane.addedUser.dataSource = this.documentHelper.userCollection.slice();
            this.documentHelper.restrictEditingPane.addedUser.dataBind();
        };
        /**
         * @private
         * @returns {void}
         */
        this.okButtonClick = () => {
            this.documentHelper.restrictEditingPane.isAddUser = true;
            this.documentHelper.restrictEditingPane.showStopProtectionPane(false);
            this.documentHelper.restrictEditingPane.addUserCollection();
            this.documentHelper.restrictEditingPane.isAddUser = false;
            this.documentHelper.dialog.hide();
        };
        /**
         * @private
         * @returns {void}
         */
        this.hideDialog = () => {
            this.textBoxInput.value = '';
            this.documentHelper.dialog.hide();
        };
        /**
         * @private
         * @returns {void}
         */
        this.onKeyUpOnDisplayBox = () => {
            this.addButton.disabled = this.textBoxInput.value === '';
        };
        /**
         * @returns {void}
         */
        this.addButtonClick = () => {
            if (this.validateUserName(this.textBoxInput.value)) {
                this.bindListData(this.textBoxInput.value);
                this.textBoxInput.value = '';
            }
            else {
                DialogUtility.alert('Invalid user name');
            }
        };
        /**
         * @returns {void}
         */
        this.deleteButtonClick = () => {
            const index = this.documentHelper.userCollection.indexOf(this.userList.getSelectedItems().text);
            if (index > -1) {
                this.documentHelper.userCollection.splice(index, 1);
                this.userList.dataSource = this.documentHelper.userCollection.slice();
                this.userList.dataBind();
            }
        };
        this.documentHelper = documentHelper;
    }
    initUserDialog(localValue, isRtl) {
        //const id: string = this.documentHelper.owner.containerId + '_addUser';
        this.target = createElement('div', { className: 'e-de-user-dlg' });
        const headerValue = localValue.getConstant('Enter User');
        const dlgFields = createElement('div', { innerHTML: headerValue, className: 'e-bookmark-dlgfields' });
        this.target.appendChild(dlgFields);
        const commonDiv = createElement('div', { className: 'e-de-user-dlg-common' });
        this.target.appendChild(commonDiv);
        const adduserDiv = createElement('div', { className: 'e-de-user-dlg-list' });
        commonDiv.appendChild(adduserDiv);
        if (isRtl) {
            adduserDiv.classList.add('e-de-rtl');
        }
        // const textBoxDiv: HTMLElement = createElement('div', { className: 'e-de-dlg-container' });
        // adduserDiv.appendChild(textBoxDiv);
        this.textBoxInput = createElement('input', { className: 'e-input e-de-user-dlg-textbox-input', attrs: { autofocus: 'true' } });
        this.textBoxInput.setAttribute('type', 'text');
        adduserDiv.appendChild(this.textBoxInput);
        this.textBoxInput.addEventListener('keyup', this.onKeyUpOnDisplayBox);
        const addButtonElement = createElement('button', {
            innerHTML: localValue.getConstant('Add'),
            attrs: { type: 'button' }
        });
        adduserDiv.appendChild(addButtonElement);
        addButtonElement.addEventListener('click', this.addButtonClick);
        this.addButton = new Button({ cssClass: 'e-de-user-add-btn' });
        this.addButton.disabled = true;
        this.addButton.appendTo(addButtonElement);
        this.addButton.addEventListener('click', this.addButtonClick);
        const userCollectionDiv = createElement('div');
        commonDiv.appendChild(userCollectionDiv);
        const userDiv = createElement('div', { innerHTML: localValue.getConstant('Users'), className: 'e-de-user-dlg-user' });
        userCollectionDiv.appendChild(userDiv);
        const listviewDiv = createElement('div');
        userCollectionDiv.appendChild(listviewDiv);
        this.userList = new ListView({
            cssClass: 'e-de-user-listview'
        });
        this.userList.appendTo(listviewDiv);
    }
    /**
     * @param {string} data - Specifies the data.
     * @private
     * @returns {void}
     */
    bindListData(data) {
        if (this.documentHelper.userCollection.indexOf(data) === -1) {
            this.documentHelper.userCollection.push(data);
        }
        if (this.userList) {
            this.userList.dataSource = this.documentHelper.userCollection.slice();
            this.userList.dataBind();
        }
    }
    validateUserName(value) {
        if (value.indexOf('@') === -1) {
            return false;
        }
        else {
            const parts = value.split('@');
            const domain = parts[1];
            if (domain.indexOf('.') === -1) {
                return false;
            }
            else {
                const domainParts = domain.split('.');
                const ext = domainParts[1];
                if (domainParts.length > 2) {
                    return false;
                }
                if (ext.length > 4 || ext.length < 2) {
                    return false;
                }
            }
        }
        return true;
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.textBoxInput) {
            this.textBoxInput = undefined;
        }
        if (this.addButton) {
            this.addButton.destroy();
            this.addButton = undefined;
        }
        if (this.userList) {
            this.userList.destroy();
            this.userList = undefined;
        }
        this.documentHelper = undefined;
    }
}
